var map = {
	"./baseAvatar.png": 4104,
	"./bg-onboarding.jpg": 4057,
	"./cross.png": 76,
	"./kafsh.svg": 4728,
	"./logo-salek-192.png": 8590,
	"./logo-salek-192x-192.png": 7782,
	"./notSeen.png": 4372,
	"./seen.png": 7773,
	"./success.png": 2369,
	"./warning.png": 2033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8121;